import {
    MessageBox,
    Dialog
} from "element-ui";
export default {
    /**
     * 获取秒数时间戳
     * @param {array} datetime
     */
    timeFormat (datetime) {
        if (datetime) {
            return datetime.map(item => Math.round(item / 1000));
        }
    },
    /**
     * 存储localStorage
     */
    setStore (name, content) {
        if (!name) return;
        if (typeof content !== "string") {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    },
    /**
     * 获取localStorage
     */
    getStore (name) {
        if (!name) return;
        return JSON.parse(localStorage.getItem(name));
    },

    /**
     * 删除localStorage
     */
    removeStore (name) {
        if (!name) return;
        window.localStorage.removeItem(name);
    },

    /**
     * 验证手机号码是否正确
     * @param tel
     * @return {boolean}
     */
    isTel (tel) {
        return /^1[3|4|5|8][0-9]\d{4,8}$/.test(tel);
    },

    /**
     * 验证是否为邮箱
     *
     * @param source
     * @return {boolean}
     */
    isEmail (source) {
        var regex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (
            source.search(
                /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
            ) != -1
        ) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 返回两位的小数的字符串
     */
    toFixedNum (num) {
        const tonum = Number(num).toFixed(2);
        return tonum;
    },

    /**
     * 将时间戳转换为日期 : 2019-08-01 10:52:53  或  2019-08-01
     * @param {int} timestamp
     * @param {string}} type
     * @use this.$util.timestampToTime(1567958400) || this.$util.timestampToTime(1567958400,'date') || this.$util.timestampToTime(1567958400,'minutes')
     */
    timestampToTime (timestamp, type) {
        if (!timestamp || timestamp == 0 || timestamp == "") {
            return;
        }

        //时间戳为10位 *1000
        let len = timestamp.toString().split("");
        if (len.length < 13) {
            timestamp = timestamp * 1000;
        }

        var date = new Date(timestamp);
        var Y = date.getFullYear() + "-";

        var M =
            (date.getMonth() + 1 < 10 ?
                "0" + (date.getMonth() + 1) :
                date.getMonth() + 1) + "-";

        var D =
            (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

        var h =
            (date.getHours() < 10 ? "0" + date.getHours() : date.getHours());

        var m =
            (date.getMinutes() < 10 ?
                "0" + date.getMinutes() :
                date.getMinutes());

        var s =
            date.getSeconds() < 10 ?
                "0" + date.getSeconds() :
                date.getSeconds();

        if (type && type == "date") {
            //年月日
            return Y + M + D;
        } else if (type && type == 'minutes') {
            //年月日时分
            return Y + M + D + h + ":" + m;
        } else {
            //年月日时分秒
            return Y + M + D + h + ":" + m + ":" + s;
        }
    },
    timeFormatByNum (time, num) {
        if (!time) {
            return;
        }
        if (num == 8) {
            // YYYYMMDD
            return String(time.getFullYear()) + (time.getMonth() + 1).toString().padStart(2, "0") + time.getDate().toString().padStart(2, "0")
        }
        if (num == 6) {
            // YYYYMM
            return String(time.getFullYear()) + (time.getMonth() + 1).toString().padStart(2, "0")
        }
    },

    //限制输入整数，浮点数
    onInput (ele, binding, vnode) {
        function handle () {
            // 手动触发数据的双向绑定,解决表单验证问题
            if (vnode.componentInstance) {
                vnode.componentInstance.$emit("input", ele.value);
            } else {
                vnode.elm.dispatchEvent(new CustomEvent("input", ele.value));
            }
            let val = ele.value;
            // modifiers为修饰符对象，传入了float，则其float属性为true
            if (binding.modifiers.float) {
                // 清除"数字"和"."以外的字符
                val = val.replace(/[^\d.]/g, "");
                // 只保留第一个, 清除多余的
                val = val.replace(/\.{2,}/g, ".");
                // 第一个字符如果是.号，则补充前缀0
                val = val.replace(/^\./g, "0.");
                if (typeof binding.value !== "undefined") {
                    // 期望保留的最大小数位数
                    let pointKeep = 0;
                    if (
                        typeof binding.value === "string" ||
                        typeof binding.value === "number"
                    ) {
                        pointKeep = parseInt(binding.value);
                    }
                    if (!isNaN(pointKeep)) {
                        if (!Number.isInteger(pointKeep) || pointKeep < 0) {
                            pointKeep = 0;
                        }
                        const str = "^(\\d+)\\.(\\d{" + pointKeep + "}).*$";
                        const reg = new RegExp(str);
                        if (pointKeep === 0) {
                            // 不需要小数点
                            val = val.replace(reg, "$1");
                        } else {
                            // 通过正则保留小数点后指定的位数
                            val = val.replace(reg, "$1.$2");
                        }
                    }
                } else {
                    val = ele.value.replace(/[^\d]/g, "");
                }
                ele.value = val;
            } else {
                let _value = ele.value.replace(/[^\d]/g, "") + ""
                if (_value.indexOf("0") == 0) {
                    _value = Math.abs(_value)
                }
                ele.value = _value
            }
        }
        return handle;
    },
    // 使用textarea标签按Enter键后web页面中成换行
    formatSolution (s) {
        if (s) {
            return s
                .replace(/\r\n/g, "<br/>")
                .replace(/\n/g, "<br/>")
                .replace(/\s/g, "&nbsp;");
        } else return "";
    },
    //图片预览
    handlePreviewImg (new_path, name, item) {
        let path = '';
        if (new_path) {
            path = new_path
        } else {
            if (item.response) {
                path = item.response.data.file_path
            } else {
                path = item.path
            }
        }
        if (
            path.indexOf("jpg") != -1 ||
            path.indexOf("jpeg") != -1 ||
            path.indexOf("bmp") != -1 ||
            path.indexOf("gif") != -1 ||
            path.indexOf("png") != -1
        ) {
            // MessageBox.alert(
            //     '<img style="width:100%" src="' + path + '" />',
            //     "图片预览",
            //     {
            //         dangerouslyUseHTMLString: true,
            //         closeOnClickModal: true
            //     }
            // );
            var $a = document.createElement("a");
            $a.setAttribute("href", path);
            $a.setAttribute("target", "_blank");
            $a.dispatchEvent(
                new MouseEvent("click", {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );
        } else {
            var $a = document.createElement("a");
            $a.setAttribute("href", path);
            $a.setAttribute("download", name);
            $a.dispatchEvent(
                new MouseEvent("click", {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );
        }
    },
    //表格长按滚动
    dragtableList (scroll_left) {
        var dv = document.querySelector('.el-table__body-wrapper'), ox;
        //上一次的位置 scrollLeft
        var last_left = 0;
        dv.onmousedown = function (e) {
            dv.onmousemove = mousemove;
            dv.onmouseup = mouseup;
            dv.onmouseleave = onmouseleave;
            e = e || window.event;
            //如果上次有记录
            if (last_left < 0) {
                //就减掉上次的距离
                ox = e.clientX - last_left;
            } else {
                //如果滚动条有操作过
                if (dv.scrollLeft > e.clientX) {
                    ox = dv.scrollLeft;
                } else {
                    ox = e.clientX - dv.scrollLeft;
                    ox = e.clientX;
                }

            }
        }, 60;
        function mousemove (e) {
            e = e || window.event;
            if (last_left < 0) {
                last_left = e.clientX - ox;
                dv.scrollLeft = ox - e.clientX;
            } else {
                last_left = e.clientX - ox;
            }

        }
        function mouseup (e) {
            dv.onmouseup = dv.onmousemove = null;
        }
        function onmouseleave () {
            dv.onmouseup = dv.onmousemove = null;
        }
    }
};
